import type {ColorPalette} from "@chakra-ui3/react";

const colorPalette: ColorPalette[] = ["red", "blue", "green", "yellow", "purple", "orange"];

export const pickPalette = (name: string | undefined): ColorPalette => {
  if (name == null || name.length == 0) return "gray";

  const index = name.charCodeAt(0) % colorPalette.length;
  return colorPalette[index];
};
